import {
  Component, ElementRef, inject, OnInit, ViewChild,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrls: ['./language-switcher.component.scss'],
    imports: [TranslatePipe],
})
export class LanguageSwitcherComponent implements OnInit {
  @ViewChild('languageCollapse') languageCollapse?: ElementRef<HTMLAnchorElement>;

  languages = [
    { name: 'Deutsch', code: 'de' },
    { name: 'English', code: 'en' },
  ];

  selected = { name: 'English', code: 'en' };

  private languageService = inject(LanguageService);

  ngOnInit(): void {
    this.selected = this.languages.find((lang) => lang.code === this.languageService.getPreferredLanguage())!;
  }

  changeLanguage(code: string): void {
    this.languageService.changeLanguage(code, true);
    this.selected = this.languages.find((lang) => lang.code === code)!;
  }
}
